import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SdkInsightSectionComponent } from '../sdk-insight-section';

@Component({
  selector: 'app-sdk-identity',
  templateUrl: './sdk-identity.component.html',
  styleUrls: ['./sdk-identity.component.scss', '../sdk-insight-section.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdkIdentityComponent extends SdkInsightSectionComponent {
  data: any;

  constructor() {
    super();
    this._sdkInsightStateService.sdk$.subscribe(data => {
      this.data = data;
    });
  }
}
